import type { FC } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { SmallCaps } from '#src/atoms/typography/SmallCaps/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

const DefaultSup = styled.sup`
  font-size: inherit;
`;

type Props = {
  i18n?: MessageDescriptor;
  align?: 'center' | 'top';
  ordinal: number;
  Sup?: FC<any>;
};
export const Ordinal = ({
  i18n = glossary.ordinalStyled,
  align = 'top',
  Sup = DefaultSup,
  ordinal,
}: Props) => {
  if (align === 'top') {
    return (
      <FormattedMessage
        {...i18n}
        values={{ ordinal, sup: c => <Sup>{c}</Sup> }}
      />
    );
  }
  return (
    <Horizontal gap={0.5} as="span">
      <FormattedMessage
        {...i18n}
        values={{
          ordinal,
          sup: c => <SmallCaps>{c}</SmallCaps>,
        }}
      />
    </Horizontal>
  );
};
